import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { UserService } from '../shared/services/user.service';
import { Router } from "@angular/router";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    public inj: Injector,
    private router: Router,
  ) {


  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const auth = this.inj.get(UserService);
    const authToken = auth.token;

    //check to see if we're already on the login page (an api call is made to check the email address / username and we don't need authorization for this)
    //also check if logout call is being made, allow this to avoid infinite loop
    if (this.router.url.includes('/login') || request.url.includes('api/v1/user/logout/') || request.url.includes('api/v1/user/reset/')) {
      return next.handle(request.clone())
    }

    if (authToken && authToken !== 'null') {
      let expiry: unknown;
      try {
        expiry = JSON.parse(atob(authToken.split('.')[1])).exp;
      } catch (error) {
        auth.redirectToLogin();
        return throwError(new HttpErrorResponse({
          status: 401,
          statusText: 'Invalid authentication token',
          url: request.url,
          error
        }));
      }
      if (typeof expiry === 'number' && expiry * 1000 > Date.now()) {
        return next.handle(
          request.clone({
            setHeaders: {
              Authorization: `Bearer ${auth.token}`
            }
          })
        )
      }

    }
    auth.redirectToLogin();
    return throwError(new HttpErrorResponse({
      status: 401,
      statusText: 'Authentication required',
      url: request.url
    }));

  }
}
